// /* eslint-disable @typescript-eslint/no-unused-vars */

// import React, { ChangeEvent, useState } from "react";

// import { images } from "../../constants";
// import { AppWrap, MotionWrap } from "../../wrapper";

// // import "./InlineFooter.scss";
// import "./NewInlineFooter.scss";

// type FooterFormData = {
//   name: string;
//   email: string;
//   message: string;
// };

// const Footer = () => {
//   const [formData, setFormData] = useState<FooterFormData>({
//     name: "",
//     email: "",
//     message: "",
//   });
//   const [isFormSubmitted, setIsFormSubmitted] = useState<boolean>(false);
//   const [loading, setLoading] = useState<boolean>(false);

//   const { name, email, message } = formData;

//   const handleChangeInput = (
//     e: ChangeEvent<HTMLInputElement> | ChangeEvent<HTMLTextAreaElement>
//   ) => {
//     const { name, value } = e.target;

//     setFormData({ ...formData, [name]: value });
//   };

//   const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
//     // setLoading(true);

//     // const contact = {
//     //   _type: "contact",
//     //   name,
//     //   email,
//     //   message,
//     // };

//     // console.log("** INLINE FOOTER **\n", contact);
//     // setLoading(false);

//     //@ts-ignore
//     // client.create(contact).then(() => {
//     //   setLoading(false);
//     //   setIsFormSubmitted(true);
//     // });

//     e.preventDefault();

//     if (!name || !email || !message) return;
//     setLoading(true);

//     const form = e.currentTarget;
//     const formDataObj = new FormData(form);
//     formDataObj.append("form-name", "ghost-inline");

//     try {
//       await fetch("/", {
//         method: "POST",
//         body: formDataObj,
//       });

//       setLoading(false);
//       setIsFormSubmitted(true);
//     } catch (err) {
//       console.error("Netlify submission failed:", err);
//       setLoading(false);
//     }
//   };

//   return (
//     <>
//       <h2 className="app__footer-inline-header">
//         Ready to take <span className="text-purple">your</span> digital presence
//         to the next level?
//       </h2>
//       {!isFormSubmitted ? (
//         <>
//           <p className="app__footer-text-message">
//             Reach out to me today and let&apos;s discuss how I can help you
//             achieve your goals.
//           </p>
//           {/* <div className="app__footer-cards"> */}
//           {/* <div className="app__footer-card">
//           <img src={images.email} alt="email" />
//           <a href="mailto:ashley@algorhythmsnare.com" className="p-text">
//             ashley@algorhythmsnare.com
//           </a>
//         </div> */}
//           {/* <div className="app__footer-card">
//           <img src={images.mobile} alt="mobile" />
//           <a href="tel: +31 (06) 13691840" className="p-text">
//             +31 (06) 13691840
//           </a>
//         </div> */}
//           {/* </div> */}

//           <form
//             className="app__footer-form app__flex"
//             method="POST"
//             name="ghost-inline"
//             //@ts-ignore
//             netlify
//             data-netlify="true"
//             data-netlify-honeypot="bot-field"
//             onSubmit={handleSubmit}
//           >
//             <input type="hidden" name="form-name" value="ghost-inline" />
//             <input type="hidden" name="bot-field" />
//             <div className="app__flex">
//               <input
//                 className="p-text"
//                 name="name"
//                 type="text"
//                 placeholder="Your Name"
//                 value={name}
//                 onChange={handleChangeInput}
//               />
//             </div>
//             <div className="app__flex">
//               <input
//                 className="p-text"
//                 name="email"
//                 type="email"
//                 placeholder="Your Email"
//                 value={email}
//                 onChange={handleChangeInput}
//               />
//             </div>
//             <div>
//               <textarea
//                 className="p-text"
//                 placeholder="Your Message"
//                 value={message}
//                 name="message"
//                 onChange={handleChangeInput}
//               />
//             </div>
//             <button type="button" className="p-text">
//               {loading ? "Sending" : "Send Message"}
//             </button>
//           </form>
//         </>
//       ) : (
//         <div>
//           <h2 className="footer-result">
//             Thank you for getting in touch. I will respond to your query within
//             24 hours.
//           </h2>
//         </div>
//       )}
//     </>
//   );
// };

// export default Footer;

// import React, { ChangeEvent, useRef, useState } from "react";

// import { AppWrap, MotionWrap } from "../../wrapper";
// import "./NewInlineFooter.scss";

// type FooterFormData = {
//   name: string;
//   email: string;
//   message: string;
// };

// const Footer = () => {
//   const formRef = useRef<HTMLFormElement | null>(null);

//   const [formData, setFormData] = useState<FooterFormData>({
//     name: "",
//     email: "",
//     message: "",
//   });

//   const [isFormSubmitted, setIsFormSubmitted] = useState(false);
//   const [loading, setLoading] = useState(false);

//   const { name, email, message } = formData;

//   const handleChangeInput = (
//     e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
//   ) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({ ...prev, [name]: value }));
//   };

//   const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
//     e.preventDefault();

//     if (!name || !email || !message) return;

//     setLoading(true);

//     const isProduction = process.env.NODE_ENV === "production";

//     if (isProduction && formRef.current) {
//       // Let Netlify handle the real submission
//       formRef.current.submit();
//     } else {
//       // Local dev: fake success after short delay
//       setTimeout(() => {
//         setLoading(false);
//         setIsFormSubmitted(true);
//       }, 600);
//     }
//   };

//   return (
//     <>
//       <h2 className="head-text">
//         Ready to take <span className="text-purple">your</span> digital presence
//         to the next level?
//       </h2>

//       {!isFormSubmitted && (
//         <p className="app__footer-text-message">
//           Reach out to me today and let’s discuss how I can help you achieve
//           your goals.
//         </p>
//       )}

//       {!isFormSubmitted ? (
//         <form
//           ref={formRef}
//           className="app__footer-form app__flex"
//           method="POST"
//           action="/"
//           name="ghost-inline"
//           data-netlify="true"
//           data-netlify-honeypot="bot-field"
//           onSubmit={handleSubmit}
//         >
//           {/* Netlify required fields */}
//           <input type="hidden" name="form-name" value="ghost-inline" />
//           <input type="hidden" name="bot-field" />

//           <div className="app__flex">
//             <input
//               className="p-text"
//               name="name"
//               type="text"
//               placeholder="Your Name"
//               value={name}
//               onChange={handleChangeInput}
//               required
//             />
//           </div>

//           <div className="app__flex">
//             <input
//               className="p-text"
//               name="email"
//               type="email"
//               placeholder="Your Email"
//               value={email}
//               onChange={handleChangeInput}
//               required
//             />
//           </div>

//           <div>
//             <textarea
//               className="p-text"
//               name="message"
//               placeholder="Your Message"
//               value={message}
//               onChange={handleChangeInput}
//               required
//             />
//           </div>

//           <button type="submit" className="p-text" disabled={loading}>
//             {loading ? "Sending…" : "Send Message"}
//           </button>
//         </form>
//       ) : (
//         <div className="footer-result">
//           <h3>Thanks for reaching out 👋🏿</h3>
//           <p>I’ll get back to you within 24 hours.</p>
//         </div>
//       )}
//     </>
//   );
// };

// export default AppWrap(
//   MotionWrap(Footer, "app__footer"),
//   "contact",
//   "app__whitebg",
// );

import React, { ChangeEvent, useState } from "react";
import { AppWrap, MotionWrap } from "../../wrapper";
import "./NewInlineFooter.scss";

type FooterFormData = {
  name: string;
  email: string;
  message: string;
};

const Footer = () => {
  const [formData, setFormData] = useState<FooterFormData>({
    name: "",
    email: "",
    message: "",
  });
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const { name, email, message } = formData;

  const handleChangeInput = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    const target = e.target as HTMLInputElement | HTMLTextAreaElement;
    setFormData({ ...formData, [target.name]: target.value });
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setError(null);

    if (!name || !email || !message) {
      setError("Please fill out all fields.");
      return;
    }

    setLoading(true);

    // Local dev simulation
    if (window.location.hostname === "localhost") {
      setTimeout(() => {
        setLoading(false);
        setIsFormSubmitted(true);
      }, 800);
      return;
    }

    // Netlify form submission
    try {
      const form = e.currentTarget;
      const formDataObj = new FormData(form);
      formDataObj.append("form-name", "ghost-inline");

      await fetch("/", {
        method: "POST",
        body: formDataObj,
      });

      setLoading(false);
      setIsFormSubmitted(true);
    } catch (err) {
      console.error("Form submission failed:", err);
      setError("Something went wrong. Please try again.");
      setLoading(false);
    }
  };

  return (
    <>
      <h2 className="head-text">
        Ready to take <span className="text-purple">your</span> digital presence
        further?
      </h2>

      {!isFormSubmitted && (
        <p className="app__footer-text-message">
          Let’s discuss how I can help you achieve your goals online.
        </p>
      )}

      {error && <p className="app__footer-text-message error">{error}</p>}

      {!isFormSubmitted ? (
        <form
          className="app__footer-form app__flex"
          name="ghost-inline"
          method="POST"
          data-netlify="true"
          data-netlify-honeypot="bot-field"
          onSubmit={handleSubmit}
        >
          <input type="hidden" name="form-name" value="ghost-inline" />
          <input type="hidden" name="bot-field" />

          <div className="app__flex">
            <input
              className="p-text"
              type="text"
              name="name"
              placeholder="Your Name"
              value={name}
              onChange={handleChangeInput}
            />
          </div>

          <div className="app__flex">
            <input
              className="p-text"
              type="email"
              name="email"
              placeholder="Your Email"
              value={email}
              onChange={handleChangeInput}
            />
          </div>

          <div>
            <textarea
              className="p-text"
              name="message"
              placeholder="Your Message"
              value={message}
              onChange={handleChangeInput}
            />
          </div>

          <button type="submit" className="p-text">
            {loading ? "Sending..." : "Send Message"}
          </button>
        </form>
      ) : (
        <div>
          <h2 className="footer-result">
            Thank you for getting in touch. I will respond to your query within
            24 hours.
          </h2>
        </div>
      )}
    </>
  );
};

export default AppWrap(
  MotionWrap(Footer, "app__footer"),
  "contact",
  "app__hitebg",
);
